import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1.27 1.73L0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 1.27 1.73zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm16-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99H22V2z"
}), 'SpeakerNotesOffSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpeakerNotesOffSharp.js
// module id = 6343
// module chunks = 2